import React from 'react'
import Typography from '@material-ui/core/Typography'
import { useTranslation } from 'react-i18next'

/**
 * The thank-you, said only about things the server confirmed.
 *
 * Two changes of substance over what Checkout rendered inline:
 *
 * - "we have emailed you confirmation" (A14) was shown to every payer. A document with no
 *   email address on it emails nobody, and the payer then waits for a message that is never
 *   coming instead of saving the page. It now appears only when `emailed` came back true.
 * - `pending` is the 30-second confirm timeout: the card was approved but the document is
 *   not written yet. It reads as success, because it IS success -- the money is gone. A
 *   failure message here starts a support call and invites a second payment.
 */
export default function Thank({ state }) {
  const { t } = useTranslation()
  const { docnum, emailed, pending } = state || {}

  if (pending) {
    return (
      <React.Fragment>
        <Typography variant="h5" gutterBottom>{t('ThankYouForYourOrder')}</Typography>
        <Typography variant="subtitle1">{t('DocumentBeingIssued')}</Typography>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <Typography variant="h5" gutterBottom>{t('ThankYouForYourOrder')}</Typography>
      {docnum && (
        <Typography variant="subtitle1">
          {t('YourDocumentNumber')} {docnum}
        </Typography>
      )}
      {emailed && (
        <Typography variant="subtitle1">{t('WeHaveEmailedYouConfirmation')}</Typography>
      )}
    </React.Fragment>
  )
}
